import schema from '../form-configs/schema';
import data from '../form-configs/data';
import layout from '../form-configs/layout';

export const adjustIncreaseDecrease = context => ({
  schema: {
    ...schema(context),
  },
  formModel: {
    ...data,
  },
  layout: {
    ...layout,
  },
});

export default adjustIncreaseDecrease;



// WEBPACK FOOTER //
// ./src/portal-components/invoice/actions-invoice/form-definition/adjust-increase-decrease.js